
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  Legend
} from "recharts";
import { ChartDataPoint } from "@/types/puttingResults";
import { getTestColor } from "./TestColorConfig";
import { translateExerciseName } from "@/utils/exerciseTranslations";
import { useTranslation } from 'react-i18next';

interface CombinedChartProps {
  filteredTestTypes: string[];
  filteredChartData: Record<string, ChartDataPoint[]>;
  pointsDomain: [number, number];
}

const CombinedChart: React.FC<CombinedChartProps> = ({ 
  filteredTestTypes, 
  filteredChartData, 
  pointsDomain 
}) => {
  const { t } = useTranslation('common');

  return (
    <div className="h-[350px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart 
          margin={{ top: 10, right: 30, left: 0, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="date" 
            tick={{ fontSize: 12 }}
            tickMargin={8}
            allowDuplicatedCategory={false}
          />
          <YAxis 
            orientation="left" 
            domain={pointsDomain}
            tick={{ fontSize: 12 }}
            tickMargin={8}
            width={30}
            allowDecimals={false}
            label={{ value: 'Points', angle: -90, position: 'insideLeft', offset: -15 }}
          />
          <Tooltip 
            formatter={(value, name) => [`${value} pts`, name]}
          />
          <Legend />
          
          {filteredTestTypes.map(testType => (
            <Line
              key={testType}
              data={filteredChartData[testType] || []}
              type="monotone"
              dataKey="points"
              name={translateExerciseName(testType, t)}
              stroke={getTestColor(testType)}
              strokeWidth={2}
              dot={{ strokeWidth: 2, r: 4, fill: getTestColor(testType) }}
              activeDot={{ strokeWidth: 0, r: 6, fill: getTestColor(testType) }}
              isAnimationActive={true}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CombinedChart;
